import { FreetypeSearchType, routes } from "@/common/utils/routes";
import { searchTabsEnum } from "../Tabs";
import { Link } from "react-router-dom";
import { mainBus } from "@/common/buses";
import { useMemo } from "react";
import "./MoreResultsLink.scss";

interface IMoreResultsLink {
  activeTab: Exclude<searchTabsEnum, searchTabsEnum.ALL>;
  searchValue: string;
}

export const MoreResultsLink = ({ activeTab, searchValue }: IMoreResultsLink) => {
  const tabRoutes = useMemo(() => ({
    [searchTabsEnum.CREATORS]: routes.freetypeSearch(FreetypeSearchType.creators, { query: searchValue }),
    [searchTabsEnum.NICHES]: routes.freetypeSearch(FreetypeSearchType.niches, { query: searchValue }),
    [searchTabsEnum.TAGS]: routes.search(searchValue),
  }), [searchValue]);

  return (
    <div className="moreResultsLink">
      <Link to={tabRoutes[activeTab]} onClick={() => mainBus.emit("close_search")}>See more {activeTab}</Link>
    </div>
  );
};
